<template>
  <el-select
    v-bind:value="value"
    v-bind="$attrs"
    v-on="changeListeners"
  >
    <el-option
      v-for="option in optionObj"
      :label="option.label"
      :value="option.value"
      :key="`${name}${option.label}`"
    ></el-option>
  </el-select>
</template>

<script>
import { booleanOptions } from "@/utils/common";

export default {
  name: "bool-select",
  props: {
    name: {
      type: String,
      default: "",
    },
    value: {
      type: Boolean,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    optionObj: {
      type: Array,
      default: () => booleanOptions,
    }
  },
  data() {
    return {};
  },
  computed: {
    changeListeners() {
      const vm = this;
      return Object.assign(
        {},
        this.$listeners,
        {
          input: function(_value) {
            vm.$emit("input", _value);
          },
          change: function(_value) {
            vm.$emit("change", _value);
          }
        }
      );
    },
  },
  methods: {

  },
};
</script>